import React from "react"
import styled from "styled-components"
import {SelectOption as SelectOptionType} from "../Select"

const StyledLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: initial;
`

const FlexRow = styled.div`
  align-items: center;
  display: flex;
  margin-left: 2px;
  margin-right: 2px;
  max-width: calc(100% - 8px);
  white-space: nowrap;
`

const SelectPill = ({
  innerRef,
  innerProps,
  data,
  selectProps,
  label
}: {
  innerRef: any,
  innerProps: any,
  data: any,
  selectProps: any,
  label: string
}) => {
  const {
    components: {OptionIcon, OptionLabel},
    labelKey,
    valueKey,
    options
  } = selectProps
  const value = data[valueKey]
  const selectedItem = options.find((option: SelectOptionType) => option[valueKey] === value) || data

  return (
    <FlexRow ref={innerRef} {...innerProps}>
      {OptionIcon && <OptionIcon {...selectedItem} />}
      <StyledLabel>{OptionLabel ? <OptionLabel {...data} /> : label || selectedItem[labelKey]}</StyledLabel>
    </FlexRow>
  )
}

export default SelectPill
